/*
 * ログインLPのコンポーネント
 */
const Report = () => {
  return import('@/pages/LoginLp/Report')
}
const Operation = () => {
  return import('@/pages/LoginLp/Operation')
}
const Simulation = () => {
  return import('@/pages/LoginLp/SimulationList')
}
const SimulationAdd = () => {
  return import('@/pages/LoginLp/SimulationAdd')
}
const SimulationEdit = () => {
  return import('@/pages/LoginLp/SimulationEdit')
}
const SimulationReadonly = () => {
  return import('@/pages/SimulationReadonly')
}

export const loginLpRoutes = [
  // ログインLP:レポート
  {
    path: '/loginlp/report',
    name: 'Report',
    component: Report,
    meta: { requireAuth: true },
  },
  // ログインLP:運用
  {
    path: '/loginlp/operation',
    name: 'Operation',
    component: Operation,
    meta: { requireAuth: true },
  },
  // ログインLP:シミュレーション
  {
    path: '/loginlp/simulations',
    name: 'LoginLpSimulation',
    component: Simulation,
    meta: { requireAuth: true },
  },
  // ログインLP:シミュレーション登録
  {
    path: '/loginlp/simulations/add',
    name: 'LoginLpSimulationAdd',
    component: SimulationAdd,
    meta: { requireAuth: true },
    props: {
      passedFrom: null,
    },
  },
  // ログインLP:シミュレーション編集
  {
    path: '/loginlp/simulations/:simulationId/edit',
    name: 'LoginLpSimulationEdit',
    component: SimulationEdit,
    meta: { requireAuth: true },
    props: {
      initialStep: null,
    },
  },
  // ログインLP:シミュレーション参照
  {
    path: '/simulations/readonly',
    name: 'SimulationReadonly',
    component: SimulationReadonly,
    meta: { requireAuth: true },
  },
]
